export const tagConfig = () => {
  return {
    padding: '.5rem 0.8rem 0.4rem',
    colorScheme: {
      light: {
        primaryBackground: '{primary.600}',
        primaryColor: 'var(--primary-surface-color)'
      },
      dark: {
        primaryBackground: '{primary.400}',
        primaryColor: 'var(--primary-surface-color)'
      }
    }
  }
}

export const tagPt = () => {
  return {
    label: {
      class: 'font-10-n'
    }
  }
}
